shvenergy.mainmenu = (function ($) {
	"use strict";

	//Cache buttons buttons
	var lvl1Buttons = $("button.main-menu__button-lvl1");
	var lvl2Buttons = $("button.main-menu__button-lvl2");
	var lvl3Buttons = $("button.main-menu__button-lvl3");

	var selectedLvl1Button = $("button.main-menu__button-lvl1[data-selected]");
	var selectedLvl2Button = $("button.main-menu__button-lvl2[data-selected]");
	var selectedLvl3Button = $("button.main-menu__button-lvl3[data-selected]");

	var selectedLvl4Blocks = $(".scroll-column.is-selected");

	var ctaColumn = $("[data-ctacolumn]"); //This is where we want to inject selected CTA's
	var ctaContainer = $(".cta-container"); //This is where CTA's are stored
	var ctaIntroCopyContainer = $(".sectionintrocopy-container"); //This is where section intro copy texts are stored

	var isSticky = (document.body.dataset.totopEnabled === 'True');

	let lvl2Menu = $(".main-menu__column.main-menu__column-lvl2");
	let lvl3Menu = $(".column.medium-6.lvl3-slide-bg");
	let newsArticleNavSticky = document.querySelector('.news__article__nav .sticky');
	let toTopEl = document.querySelector('#to-top');

    function populatePlaceholders(elem) {
        let cta1 = elem.data("ctaidone");
        let cta2 = elem.data("ctaidtwo");
        let introCopyId = elem.data("sectionintrocopyid");

        populateCtaColumn(cta1, cta2);
        populateIntroCopy(introCopyId);
    }

	function init() {

		$("#to-top").on("click", () => {
			let pageName = document.pageType == "Content page" ? document.title : document.pageType;
			shvenergy.tracking.trackRawEventData({
				'event': 'totop',
				'pagename': pageName
			});
		});

		//Handle click in lvl1 buttons
		lvl1Buttons.each(function () {
			//e.stopPropagation();

			var button = $(this);
			var otherButtons = lvl1Buttons.not(button);
      var submenu = $(button).find("+ div");

			button.on("click", function () {

        lvl1Buttons.removeClass("hide-bar");

				if (button.attr("aria-expanded") === "true") {
					closeMenu();
					return;
				}

				if (button.data("selected") !== undefined) {
					if (selectedLvl2Button.length) {
						const menuId = selectedLvl2Button.data("id");
						$("#" + menuId).addClass("active");

					populatePlaceholders(selectedLvl2Button);
					} else if (selectedLvl1Button.length) {
						const menuId = selectedLvl1Button.data("id");
					$("#" + menuId).addClass("active");

					populatePlaceholders(selectedLvl1Button);
					}
				} else {
					disableExtraLevels("lvl1");
					populatePlaceholders(button);
				}

				otherButtons.attr("aria-expanded", "false").removeClass("is-active").addClass("hide-bar");
				button.attr("aria-expanded", "true").addClass("is-active");

				var firstLink = submenu.find("a, button")[0];
				if (firstLink) {
    		// Safe to use firstLink
					firstLink.focus();
				}

				var firstLink = submenu.find("a, button")[0];
				if (firstLink) {
    		// Safe to use firstLink
					firstLink.focus();
				}

        firstLink.focus();

				$("html").addClass("show-overlay");
			});

		});

		//Handle click in lvl2 buttons
		lvl2Buttons.each(function () {
			var button = $(this);

			var otherButtons = lvl2Buttons.not(button);

			button.on("click", function () {
				const menuId = $(this).data("id");
				$(".js-col ").removeClass("active");
				$(".js-col .inner-row .column:last-child").removeClass("disable-leftborder");

				if (button.hasClass("active")) {
					button.removeClass("active");
                    $("#" + menuId).removeClass("active");
					populatePlaceholders($(".main-menu__button-lvl1.is-active"));
					lvl2Menu.removeClass("light-grey").removeClass("grey");
					button.removeClass("light-grey");
					$(".main-menu__lvl2 #lvl2-menu").css({ "border-right": "solid 1px rgba(0, 0, 0, 0.1)" });
					return;
				}

				populatePlaceholders(button);

				button.addClass("active");
				otherButtons.removeClass("active is-selected").removeClass("light-grey");
				lvl2Menu.addClass("light-grey");
				lvl3Menu.removeClass("light-grey");

				disableExtraLevels("lvl2");

				$(".main-menu__lvl2 #lvl2-menu").css({ "border-right": "none" });
				$(".js-col ").removeClass("active");
				$("#" + menuId).addClass("active");
			});
		});

		//Handle click in lvl3 buttons
		lvl3Buttons.each(function () {
			var button = $(this);
			var otherButtons = lvl3Buttons.not(button);

			button.on("click", function () {

				const menuId = $(this).data("id");
				let lvl2ActiveButton = $(".main-menu__button-lvl2.active");
				let lvl4Menu = $(".js-col.active .inner-row .column:last-child");

				if (button.hasClass("active")) {
					button.removeClass("active is-selected");
                    $("#" + menuId).removeClass("active");
					populatePlaceholders($(".main-menu__button-lvl2.active"));
					lvl2Menu.removeClass("grey").addClass("light-grey");
					lvl3Menu.removeClass("light-grey");
					lvl2ActiveButton.removeClass("light-grey");
					lvl4Menu.removeClass("disable-leftborder")
					return;
				}

				populatePlaceholders(button);

				$(".scroll-column.is-inactive").removeClass("active");

				lvl4Menu.addClass("disable-leftborder");
				button.addClass("active is-selected");
				otherButtons.removeClass("active is-selected");
				lvl2Buttons.removeClass("light-grey");
				lvl2ActiveButton.addClass("light-grey");
				lvl2Menu.removeClass("light-grey").addClass("grey");
				lvl3Menu.addClass("light-grey");

				$("#" + menuId).addClass("active");
			});

		});

		$(document).on("keyup", function (e) {
			if (e.keycode === 27) {
				closeMenu();
			}
		});

		$(document).on("click", function (e) {
			if ($(e.target).closest(".main-menu-wrapper").length === 0) {
				closeMenu();
				setCta();
			}

			trackMenuClick(e);
		});

		$(document).on("auxclick", function (e) {
			if ($(e.target).closest(".main-menu-wrapper").length === 0) {
				closeMenu();
				setCta();
			}

			trackMenuClick(e);
		});

		function trackMenuClick(e) {
			// Main menu - top level
			// Must only be tracked if a new page is opened, not when menu is opened
			if ( $(e.target).hasClass('main-menu__button-lvl1') ) {
				let name = e.target.innerText;
				if (name) {
					name = name.trim();
				}

				shvenergy.tracking.trackRawEventData({
					event: 'clickMenu',
					mainLevel: name,
					linkName: name
				});
			}

			// Main menu - lower levels
			if ($(e.target).closest(".scroll-column a").length > 0) {
				let mainLevel = $(".main-menu button.is-active").text() || "",
					linkName = e.target.text;

				if (linkName) {
					linkName = linkName.trim();
				}

				shvenergy.tracking.trackRawEventData({
					event: 'clickMenu',
					mainLevel: mainLevel,
					linkName: linkName
				});
			}
		}

		setCta();

		setupToTopButton();

		//createToTopButton();
	}

	/*function demotest() {
		let pageName = document.pageType == "Content page" ? document.title : document.pageType;
		shvenergy.tracking.trackRawEventData({
			'event': 'totop',
			'pagename': pageName
		});
	}*/
	function setupToTopButton() {
		const label = (document.body.dataset.totopLabel !== "") ? document.body.dataset.totopLabel : "";
		let header, mobile = $(".mobile-header"), desktop = $(".page-header");

		if (!toTopEl) {
			return;
		}

		if (window.matchMedia("(min-width: 1200px)").matches) {
			header = desktop;
			toTopEl.style.top = desktop.outerHeight() + "px";
		} else {
			header = mobile;
			toTopEl.style.top = mobile.outerHeight() + "px";
		}
		
		let btn = toTopEl.querySelector('button'),
			labelEl = btn.querySelector('p');
			
			labelEl.innerText = label;
			
			btn.addEventListener('click', () => {
				window.scrollTo(0, 0);
			});
			
			$(document).on('scroll', (e) => {
				if (header.offset().top >= ($(document).height() - document.documentElement.clientHeight) / 2) {
					toTopEl.classList.add('visible');
				} else {
					toTopEl.classList.remove('visible');
				}
			
			updateToTop(toTopEl);
		});

		updateToTop(toTopEl);
	}

	function updateToTop(toTopEl) {
		if (checkForStickyElements()) {
			if (document.querySelector(".togglelist.is-stuck")) {
				toTopEl.classList.add('toggleListStacked');
			} else if (document.querySelector(".squarelist.is-stuck")) {
				toTopEl.classList.add('squareListStacked');
			} else {
				toTopEl.classList.add('stacked');
			}
		}
		else {
			toTopEl.classList.remove('stacked');
			toTopEl.classList.remove('toggleListStacked');
			toTopEl.classList.remove('squareListStacked');
		}
	}

	function checkForStickyElements() {
		let hasStickyElements = false,
			elQueries = [
			'.anchor-menu.is-stuck ul',
			'.news__article__nav .sticky-container .sticky.is-stuck',
			'.news-list-nav-container.is-stuck .news-list-nav',
			'.tablist.is-stuck',
			'.togglelist.is-stuck',
			'.squarelist.is-stuck'
		];

		elQueries.forEach((elQuery) => {
			let el = document.querySelector(elQuery);

			if (el && checkElementInViewport(el)) {
				hasStickyElements = true;
			}
		});
		
		return hasStickyElements;
	}

	function checkElementInViewport(el) {
		//let el = document.querySelector('.anchor-menu.is-stuck');

		let rect = el.getBoundingClientRect();

		return rect.top >= -1 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.top <= 0;
	}

	function setCta() {
		if (window.matchMedia("(min-width: 1200px)").matches) {
			if (selectedLvl3Button.length > 0) {
				populatePlaceholders(selectedLvl3Button);
			} else if (selectedLvl2Button.length > 0) {
				populatePlaceholders(selectedLvl2Button);
			} else if (selectedLvl1Button.length > 0) {
				populatePlaceholders(selectedLvl1Button);
			}
		}
	}

    function populateCtaColumn(ctaIdOne, ctaIdTwo) {
        ctaColumn.empty();
        if (ctaIdOne) {
            ctaColumn.append(ctaContainer.find("[data-ctaid=" + ctaIdOne + "]").clone(true));
		}
        if (ctaIdTwo) {
            ctaColumn.append(ctaContainer.find("[data-ctaid=" + ctaIdTwo + "]").clone(true));
		}
	}

	function populateIntroCopy(ctaId) {
		if (ctaId) {
			const rawHtml = ctaIntroCopyContainer.find("[data-sectionintrocopyid=" + ctaId + "]").html();
			ctaColumn.prepend(rawHtml);
		}

	}

	function closeMenu() {
		lvl1Buttons.attr("aria-expanded", "false");
		lvl1Buttons.removeClass("is-active");
		lvl1Buttons.removeClass("hide-bar");

		lvl2Buttons.removeClass("active").removeClass("is-selected");
		lvl3Buttons.removeClass("active").removeClass("is-selected");

		selectedLvl2Button.addClass("active is-selected");
		selectedLvl3Button.addClass("active is-selected");

		$(".scroll-column.is-inactive").removeClass("active");
		selectedLvl4Blocks.addClass("active");


		$(".js-col.active").removeClass("active");

		shvenergy.utils.hideOverlay();
	}

	function disableExtraLevels(lvl) {	
		$(".main-menu__button-lvl3.active.is-selected").removeClass("active is-selected");
		$(".scroll-column.is-inactive").removeClass("active");
		if (lvl === "lvl1") {
			$(".js-col.active").removeClass("active");
			lvl2Buttons.removeClass("active is-selected").removeClass("light-grey");
			lvl2Menu.removeClass("light-grey").removeClass("grey");
			$(".main-menu__lvl2 #lvl2-menu").css({ "border-right": "solid 1px rgba(0, 0, 0, 0.1)" });
		}
	}
	
	if (newsArticleNavSticky) {
		$.fn.isInViewport = function() {
			const elementTop = $(this).offset().top;
			const elementBottom = elementTop + $(this).outerHeight();
	
			const viewportTop = $(window).scrollTop();
			const viewportBottom = viewportTop + $(window).height();
	
			return elementBottom > viewportTop && elementTop < viewportBottom;
		};
		$(window).on('resize scroll', function () {
			let newsArticleNavHide = $('.page-footer').offset().top - ($(".main-menu-border").outerHeight() + newsArticleNavSticky.offsetHeight);
			let header = window.matchMedia("(min-width: 1200px)").matches ? $(".main-menu-border").outerHeight() + $(".service-menu-border").outerHeight() : $(".mobile-header").outerHeight();
			
			if ($(window).scrollTop() > newsArticleNavHide && newsArticleNavSticky.classList.contains('is-stuck')) {
				toTopEl ? toTopEl.style.top = header + "px" : "";
				newsArticleNavSticky.style.opacity = "0";
				newsArticleNavSticky.style.top = "-100%";
			}
			if ($(window).scrollTop() < newsArticleNavHide) {
				toTopEl ? toTopEl.style.top = newsArticleNavSticky.offsetHeight + header + "px" : "";
				newsArticleNavSticky.style.opacity = "1";
				newsArticleNavSticky.style.top = "0";
			}
		});
	}

	init();

})(jQuery);